<template>
    <div class="privacy">
        <h1 class="privacy-title">隱私權政策</h1>
        <h5>PACA 生態圈服務網</h5>
        <h5>2018年8月23日</h5>
        <p>PACA 生態圈服務網十分重視您的隱私。為了您的隱私，我們只會收集並使用我們為您提供的產品、服務、網站和行動版應用程式 (合稱為我們的「服務」) 必要的個人資料。您的個人資料包含以下資訊：
        </p><ul>
            <li>名稱</li>
            <li>地址</li>
            <li>電話號碼</li>
            <li>出生日期</li>
            <li>電子郵件地址</li>
            <li>其他由我們收集且可以直接或間接辨識您的身分的資料。</li>
        </ul>
        <p></p>
        <p>我們的隱私權政策之立意為向您解釋我們收集資料的內容與方式，以及我們使用您的個人資料的方式和原因。其中也闡述了我們提供您存取、更新或以其他方式控管我們處理的個人資料的選項。</p>
        <h2>我們會收集哪些資訊？</h2>
        <p>我們會收集資訊，以便在您使用我們服務時提供您最佳品質的使用體驗。您在進行下列操作時，請瞭解您非常有可能被直接收集個人資料：
        </p><ol>
            <li>建立帳戶或購買我們任一服務 (如：帳單資訊，包含姓名、地址、信用卡號碼、政府身分識別)；</li>
            <li>向我們的客戶支援團隊尋求協助 (如透過電話號碼)。</li>
            <li>填寫聯絡表單或向我們要求電子報或其他資訊 (如電子郵件)；或</li>
        </ol>
        <p></p>
        <p>但是，我們在為您提供服務時，也會收集額外的資訊，以便確保達成必要且最佳的成效。這些資料收集方法可能對您來說並不明顯，因此我們想在下文進一步強調並解釋這些收集方法 (因為它們可能會有變化) 以及運作原理：</p>
        <p>我們收集的帳戶相關資訊和您使用我們的服務有關，如帳戶號碼、購買內容、產品續約或到期時間、要求資訊、客戶服務要求、註記或您要求內容的詳細資訊，以及我們回應的內容。</p>
        <p>我們網站及行動版應用程式上的 Cookie 及類似技術可讓我們追蹤您的瀏覽行為、按過的連結、購買的項目、裝置類型，並可收集您如何使用我們的服務並與之互動的各種資料，包含分析數據。這能讓我們向您提供和您關聯性較高的產品優惠、更優良的網站及行動版應用程式使用體驗，並能收集、分析、改善我們服務的品質。我們可能會收集您的位置資訊 (IP 位址) 以便讓我們為您提供量身訂做的服務。若需進一步的資訊，或想瞭解如何管理我們使用的技術。</p>
        <p>使用服務情形之資料會在您使用我們服務及與之互動時自動被系統收集，包含中繼資料、記錄檔、cookie/裝置 ID 以及地理位置資訊。資訊內容包含您在本服務內與各功能、內容及連結 (包含來自第三方的以上項目，如社交媒體外掛程式) 互動情形的特定資料、網路協定 (IP) 位址、瀏覽器類型與設定、使用本服務的日期和時間、瀏覽器設定與外掛程式相關資訊、語言偏好選項與 cookie 資料、有關裝置存取服務的資料 (包含裝置類型、作業系統、裝置設定、應用程式 ID、裝置獨特識別方式及錯誤資料)，以上收集而來的部分資料可能可以並會用來估算您所在的大概位置。</p>
        <p>我們可能會從其他來源收集到有關於您的補充資料，包括公開資料庫或由我們向其購買資料的第三方等，這些資料可能會與現有的資料整合，以便讓我們更新、擴展並分析我們記錄的正確程度、識別新客戶並提供您可能感興趣的產品和服務。如果您向我們提供他人的個人資訊，或他人向我們提供您的資訊，我們只會在提供該資訊的特定原因下使用該資訊。</p>
        <h2>我們如何使用資訊</h2>
        <p>我們秉持盡量減少收集資料之數量的做法，並將使用方式及使用目的限制於 (1) 我們有獲得許可的情形、(2) 提供您購買或進行互動的服務所需，或 (3) 法律規定或其他法律上之目的所必須採取或許可之範圍。使用情形包含：</p>
        <p><b>達成、改進、更新、加強我們為您提供的服務。</b> 我們會收集各種和您的購買內容、使用我們服務的情形和如何與之互動等相關的資訊。我們會收集此資訊，以便：
        </p><ul>
            <li>改進並最佳化我們服務的營運情形和成效 (也包含我們的網站和行動版裝置)</li>
            <li>偵測並識別任何安全性風險、錯誤、服務需加強的部分及相關問題</li>
            <li>偵測並防止有人使用我們的服務和系統進行詐欺和濫用情事</li>
            <li>收集服務使用情形的整合數據</li>
            <li>瞭解並分析您如何使用我們的服務，以及和您關聯性最高的產品和服務為何。</li>
        </ul>
        <p></p>
        <p>通常大部分收集來的資料都是個別人士如何使用我們服務的整合或統計數據資料，並未和任何個人資料有關聯，但在其本身即為個人資料、與個人資料有關聯或可能有關聯之範圍內，我們還是會將該資料視為個人資料進行處理。</p>
        <p><b>和受信任的第三方分享。</b> 我們可能會將您的個人資料分享給我們企業家族內的附屬公司、彼此合作且能讓您整合對方服務至我們服務內的第三方組織，以及我們信任的第三方服務提供商，以便讓對方代我們提供服務，如：
        </p><ul>
            <li>處理信用卡付款</li>
            <li>顯示廣告</li>
            <li>進行競賽或調查</li>
            <li>分析我們的服務和客戶的人口統計資料</li>
            <li>聯絡您，如寄送電子郵件或調查問卷</li>
            <li>管理客戶關係。</li>
        </ul>
        <p></p>
        <p>我們只會分享第三方提供您要求的服務或代我們提供服務等層面上所必要的個人資料。上述第三方 (與任何分包商) 皆須遵守嚴格的資料處理條款與條件，且不得以非契約上指定之目的 (或在未經您許可的情形下) 使用、分享或保留您的個人資料。</p>
        <p><b>和您進行通訊。</b> 我們可能會由於您註冊或透過我們購買的產品或服務而直接或透過第三方服務提供商聯絡您 (如需進行交易或服務相關之必要通訊)。 如果您有同意，或者合法利益上允許，則我們也可能會通知您瞭解其他我們認為對您有用的服務資訊。購買我們的產品或服務時您無須同意以上事項。聯絡內容可能包含：
        </p><ul>
            <li>電子郵件</li>
            <li>簡訊</li>
            <li>電話</li>
            <li>自動電話通訊或文字簡訊。</li>
        </ul>
        <p></p>
        <p>如果我們就聯名優惠方面向您收集資訊，在收集時會表明收集者資訊以及其應遵守的隱私權政策。另外，我們也會說明您在使用及/或和聯名夥伴分享個人資料等情形上擁有的選項，以及您如何實行這些選項的方法。</p>
        <p>如果您使用可匯入聯絡人的服務 (如使用電子郵件行銷服務代替您傳送電子郵件)，則我們只會為了達成您所要求的服務使用這些聯絡人和其他任何個人資訊。</p>
        <p><b>傳輸個人資料至他國。</b> 如果您在我們伺服器所在地以外的國家使用我們的服務，則您和我們之間的通訊可能會導致您的個人資料在傳輸時跨過國境。另外，如果您致電我們或啟動對談，則我們可能會在您原生國家以外的地區 (我們的全球位置之一) 為您提供支援服務。這種情形下，您的個人資料將依照本隱私權政策進行處理。</p>
        <p><b>遵守法律、法規及執法上的要求。</b> 我們與政府和執法官員及人士合作以便執行和遵守法律。若我們為了回應索賠和法律程序 (如傳票上的要求)，認為有必要或適當時，得自行將您的任何相關資訊向政府或執行官員或人士進行揭露，以保護我們或第三方的財產和權利、保護公眾或任何個人的安全，以及防止或遏止我們認為非法或不道德的活動。</p>
        <p>若法律程序上需要我們將您的個人身分識別資訊提供給第三方，則我們會在法律許可我們的範圍內，採取合理的步驟通知您。透過我們註冊網域名稱後，我們也會在遵守 ICANN 規則、任意國家代碼頂級網域規定、法規和政策之必要範圍內共享您的資訊。</p>
        <p><b>第三方網站。</b> 我們的網站和行動版應用程式內含前往第三方網站的連結。我們不對第三方網站的隱私權實踐方法或內容負責。請閱讀您前往的網站的隱私權政策。</p>
        <h2>您可以如何存取、更新或刪除資料</h2>
        <p>為方便存取、檢視、更新、刪除、移轉您的個人資料 (如果有的話)，並為了更新您的訂閱偏好設定，請登入您的帳戶，並前往「帳戶設定」。請前往我們的隱私權中心瞭解存取、更新或刪除資料的進一步資訊與說明。</p>
        <p>如果您要求刪除個人資料，而您所購買的產品或服務必須使用該資料，則我們只會刪除您已購買服務已經不需要的資料、我們合法商業目的上已不需要的資料、或者法律或契約上的紀錄保留規定已不需要保留的資料。</p>
        <p>如果您因任何理由而無法存取帳戶設定或我們的隱私權中心，可以透過以下「聯絡我們」區塊中的任一方式聯絡我們。</p>
        <h2>我們如何保障、儲存並留存您的資料</h2>
        <p>我們以一般社會標準儲存並保護我們在傳輸和接收並儲存資料後所收集的個人資料，包含在適當層面上使用加密技術。</p>
        <p>我們保留個人資料的期間以提供您要求的服務所需或其後各種合理法律或商業目的為準，不會超出上述期間。這些可能包含保留期間：
        </p><ul>
            <li>由我們經營企業時所需遵守的法律、契約或類似責任所強制要求；</li>
            <li>保留、解決、抗辯或執行我們的法律/契約權利；或</li>
            <li>維護適當且正確的商業及金融紀錄所需。</li>
        </ul>
        <p></p>
        <p>如果您對安全性或保留您個人資料的方式有任何問題，歡迎聯絡我們：service@berryan.com。</p>
        <h2>「請勿追蹤」通知</h2>
        <p>某些瀏覽器可讓您用「請勿追蹤」信號自動通知您瀏覽的網站不要進行追蹤。業界廠商對於此處所提之「請勿追蹤」信號代表的意義並無一致結論。如同許多網站及線上服務一樣，目前在收到來自訪客瀏覽器發出的「請勿追蹤」信號時，我們並不會變更我們的做法。若想進一步瞭解「請勿追蹤」的相關資訊，可參考 www.allaboutdnt.com。</p>
        <h2>年齡限制</h2>
        <p>我們的服務僅供年滿 18 歲的客戶購買，我們的服務並非以 18 歲以下的客戶為目標或讓其進行消費，也並非為吸引該類客戶消費而設計內容。若您知道或有理由確信有 18 歲以下的人士向我們提供個人資料，請聯絡我們。</p>
        <h2>隱私權政策變更</h2>
        <p>我們保留隨時修改本隱私權政策之權利。如果我們決定變更隱私權政策，我們會將該等變更公布至本隱私權政策以及我們認為適當的任何其他位置，如此您便能知悉我們收集了哪些資訊、如何使用這些資訊，以及在何種情況下 (若有的話) 會揭露該等資訊。</p>
        <h2>聯絡我們</h2>
        <p>如果您對我們的隱私權政策、我們的實踐方式或服務有任何問題、疑慮或想進行申訴，歡迎透過電子郵件聯絡我們的資料保護經理人辦公室：service@berryan.com</p>
        <p>修訂日期： 2018/8/20</p>
        <p>Copyright © since 2015 Berryan Ltd. 保留所有權利。</p>
    </div>
</template>
<script>
export default {
    name: "privacy",
    methods: {
        backPage(){
            this.$router.go(-1);
        }
    },
    activated(){
        this.$nextTick(() => {
            document.querySelector(".el-main").scrollTop = 0;
        })
    }
}
</script>